import React from "react";

interface EditPencilIconProps {
  className?: string;
}

export const EditPencilIcon = ({ className }: EditPencilIconProps) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M21.5 5.25L17.75 1.5L2.75 16.5L1.25 21.75L6.5 20.25L21.5 5.25ZM14.75 4.5L18.5 8.25L14.75 4.5ZM2.75 16.5L6.5 20.25L2.75 16.5Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

EditPencilIcon.defaultProps = {
  className: "",
};
